// project import
import dashboard from './dashboard';
import crops from './crops';
import animals from './animals';
import farmManagement from './farmManagement';
import procurement from './procurement';
import contact from './contact';
import users from './users';
import settings from './settings';
import pages from './page';

// ==============================|| MENU ITEMS ||============================== //

const menuItems = {
  items: [dashboard, crops, animals, farmManagement, procurement, contact, users, settings, pages]
};

export default menuItems;
